var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var ArrowDown = function ArrowDown(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 360 227.3' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { fill: 'currentColor', d: 'M358 44.7L313.7 1.6 183.4 135.8 45.3 1.6 2.3 46l178.4 171.4 4.9 4.8z' })
    )
  );
};
/*eslint-enable */

export default ArrowDown;
//# sourceMappingURL=ArrowDown.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/ArrowDown.js